<template>
    <CustomMultiSelect :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
        :placeholder="placeholder" item-label="label" item-value="value" :label="label"
        v-if="!loading" :required="required" :noPlaceholder="noPlaceholder"/>
</template>

<script>
import {getDocumentTypes} from "@/swagger/vue-api-client";
import CustomSelectOne from "./inner/CustomSelectOne";
import CustomMultiSelect from "./inner/CustomMultiSelect.vue";

export default {
    name: "CustomMultiSelectDocumentType",
    props: {
        name: {
            type: String,
        },
        label: {
            type: String,
        },
        emptyValue: {
            type: Boolean,
            default: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: "",
        },
        noPlaceholder: {
            type: Boolean,
            default: false,
        },
        modelValue: null,
    },

    emits: ["update:modelValue"],

    computed: {
        internalValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },

    data() {
        return {
            items: [],
            loading: false,
        };
    },

    beforeMount() {
        this.loading = true;
        getDocumentTypes().then((response) => {
            this.items = response.data;
            this.loading = false;
        });
    },

    components: {CustomMultiSelect, CustomSelectOne},
};
</script>

<style scoped>

</style>
